import React from "react";
import "../designcss/Audiencewhatwedo.css";

const ChatboxWhatwedo = () => {
  return (
    <>
      <section className="what-we-do-wrapper">
        <div className="whatwedoaudience">
          <h1 className="audiencetitle">
            Why Choose WoSender for WhatsApp Automation
          </h1>

          <p className="audiencepara">
            WoSender is built to help businesses work smarter and more
            efficiently. By combining automation, analytics, and ease of use,
            the platform enables brands to deliver fast, reliable, and
            meaningful WhatsApp conversations at scale, improving customer
            satisfaction and engagement.
          </p>

          <div className="cards-audience">
            <div className="info-audience">
              <h3>Instant Responses Around the Clock</h3>
              <p>
                WoSender ensures customer queries are answered 24/7 with
                automated messages, keeping conversations active and users
                satisfied.
              </p>
            </div>

            <div className="info-audience">
              <h3>Guided Flows That Drive Action</h3>
              <p>
                Smart flows help navigate users through structured interactions,
                making it easier to qualify leads, answer questions, and boost
                conversions effortlessly.
              </p>
            </div>

            <div className="info-audience">
              <h3>Minimize Manual Workload</h3>
              <p>
                Automated replies and smart flows handle repetitive queries
                instantly, freeing teams to focus on high-value customer
                interactions.
              </p>
            </div>

            <div className="info-audience">
              <h3>Consistent and Reliable Messaging</h3>
              <p>
                Deliver accurate, on-brand responses at every touchpoint with
                predefined flows, ensuring customers receive clear and
                dependable information throughout the conversation.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ChatboxWhatwedo;
